// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1bbIc","bigColWidth":"Table_bigColWidth__2Z5DC","biggerColWidth":"Table_biggerColWidth__lPOG1","row":"Table_row__gNzRW","col":"Table_col__BbUnm"};